import { Icon } from "@iconify/react";
import moment from "moment";
import React, { useEffect, useState } from "react";

const AdminPatientLicense = ({ patientId }) => {
  const [packages, setPackages] = useState(null);
  const issueDate = moment().format("YYYY-MM-DD");

  useEffect(() => {
    fetch(
      `https://servercareseebd.careseebd.com/api/v1/package/specific?fieldName=userId&&fieldValue=${patientId}`
    )
      .then((res) => res.json())
      .then((data) => {
        if (data?.data?.length) {
          setPackages(data.data[0]);
        }
      })
      .catch((err) => console.error("Error fetching patient license details:", err));
  }, [patientId]);

  const hasPackage = !!packages?.packageName;
  const isExpired = packages?.expireDate
    ? moment(issueDate).isAfter(packages.expireDate)
    : true;

  return (
    <div className="space-y-5 animate-fade-in">
      {/* Package Name card */}
      <div className="bg-slate-50/50 p-4 rounded-xl border border-slate-100 flex items-center gap-4">
        <div className={`p-3 rounded-xl ${hasPackage && !isExpired
          ? "bg-green-50 text-green-600"
          : "bg-red-50 text-red-500"
          }`}>
          <Icon icon="solar:document-text-bold-duotone" className="text-xl" />
        </div>
        <div>
          <span className="block text-[10px] font-bold text-slate-400 uppercase tracking-wide">
            Current Subscription Plan
          </span>
          <span className="block text-sm font-extrabold text-slate-800 mt-0.5">
            {hasPackage ? packages.packageName : "No Active Subscription"}
          </span>
        </div>
      </div>

      {/* Date fields */}
      <div className="space-y-1.5">
        <label className="block text-[11px] font-bold text-slate-500 uppercase tracking-wide">
          {packages?.expireDate ? "License Expiration Date" : "Current System Date"}
        </label>
        <div className="flex items-center gap-3 w-full max-w-sm px-4 py-3 rounded-xl border border-slate-200 bg-slate-50/50 text-xs font-semibold text-slate-700">
          <Icon icon="solar:calendar-date-linear" className="text-base text-slate-450" />
          <span>
            {packages?.expireDate
              ? moment(packages.expireDate).format("LL")
              : moment(issueDate).format("LL")}
          </span>
          {hasPackage && (
            <span className={`ml-auto inline-flex items-center px-2 py-0.5 rounded-full text-[9px] font-bold uppercase tracking-wide ${isExpired
              ? "bg-red-50 text-red-500"
              : "bg-green-50 text-green-600"
              }`}>
              {isExpired ? "Expired" : "Active"}
            </span>
          )}
        </div>
      </div>
    </div>
  );
};

export default AdminPatientLicense;
